import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Jobs() {
    return (
        <Default>
            <Head>
                <title>Veelgestelde vragen</title>
                <link rel="canonical" href={route("faq")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Op deze pagina vind je de meest gestelde vragen over WE ARE Personal Training Uden en Schijndel."
                />
                <meta
                    property="og:description"
                    content="Op deze pagina vind je de meest gestelde vragen over WE ARE Personal Training Uden en Schijndel."
                />
                <meta property="og:url" content={route("faq")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Veelgestelde vragen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-7xl">
                        Veelgestelde vragen
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="faq"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Meer informatie
                        </Link>
                    </div>
                </Hero> */}

                <div
                    className="relative xs:p-8 sm:p-8 md:p-16 lg:p-32"
                    id="faq"
                >
                    <div className="max-w-5xl mx-auto mb-8">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Beginnen zonder conditie? Geen probleem!
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Een veelvoorkomende zorg voor velen is het gebrek
                            aan conditie. "Kan ik wel beginnen met trainen als
                            ik geen conditie heb?" is een vraag die vaak gesteld
                            wordt. Bij WE ARE is het antwoord een volmondig ja.
                            Het programma is specifiek ontworpen om iedereen,
                            ongeacht hun startpunt, te helpen hun lichaam en
                            geest naar de beste versie ooit te tillen. Het maakt
                            niet uit waar je begint; wat telt, is waar je
                            naartoe gaat.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto my-8">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Wat is de investering? Dat bepaal jezelf.
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Een slimme keuze voor je gezondheid en welzijn? Dat
                            is waar onze leden voor gaan. Bij WE ARE investeer
                            je in je gezondheid, kennis én toekomst. Je kunt
                            kiezen voor ons twaalf weken programma vanaf 1335
                            euro (in drie termijnen te betalen) om mogelijk
                            daarna een nazorg abonnement te nemen vanaf 67,50
                            euro per maand. Ook is er een jaarprogramma mogelijk
                            vanaf 175 euro per maand. Wat je uiteindelijk
                            betaalt, hangt af van hoe en hoe vaak je wilt
                            trainen. In een kennismaking krijg je een gepast
                            overzicht om te bekijken welke investering het beste
                            bij je past.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto my-8">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Wat maakt WE ARE anders? Nou dit dus.
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            In een wereld vol fitnessmogelijkheden, wat maakt WE
                            ARE dan zo uniek? Het antwoord ligt in onze
                            combinatie van ons intensief programma met de
                            mogelijkheid om daarna gebruik te maken van onze
                            exclusieve nazorg, een aanpak die je nergens anders
                            in de regio vindt. Deze combinatie zorgt ervoor dat
                            je niet alleen je doelen bereikt, maar deze ook kunt
                            onderhouden. Met een limiet van tien personen
                            tegelijk en een no-bodybuilders beleid, garanderen
                            we dat je altijd toegang hebt tot de apparatuur die
                            je nodig hebt, zonder wachttijden. Bekijk ook onze
                            pagina: Waarom WE ARE?
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto my-8">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Wanneer kun je beginnen? Dat bepaal je zelf.
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            De vraag is niet wanneer je kunt beginnen, maar
                            wanneer je wilt beginnen. Bij WE ARE kun je meestal
                            binnen 7 dagen starten met jouw transformatie.
                            Dankzij ons deskundige en uitgebreide team is er
                            altijd ruimte voor jou. Het perfecte moment om te
                            starten? Dat is nu. Wachten op het perfecte moment
                            is als wachten op alle stoplichten in Nederland om
                            tegelijk op groen te springen; het gaat simpelweg
                            niet gebeuren. Het beste moment om te starten is
                            wanneer je voelt dat je klaar bent voor verandering.
                            Elke dag is de perfecte dag om een stap te zetten
                            richting jouw transformatie.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto my-8">
                        <h2 className="text-4xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            Heb je altijd resultaat? Absoluut!
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Misschien heb je onze successen al gezien op sociale
                            media en je afgevraagd: hoe is dit mogelijk? Het
                            antwoord is eenvoudig. WE ARE personal training is
                            het resultaat van minimaal vijf jaar aan verfijning
                            en perfectionering. Onze wetenschappelijk
                            onderbouwde schema’s en onze focus op mensen die hun
                            transformatie serieus nemen, hebben een ongekend
                            succespercentage opgeleverd. We selecteren op
                            voorhand of we je kunnen helpen, dat maakt ons al
                            uniek. Daarnaast zal je altijd resultaat hebben
                            wanneer je exact doet wat we van je vragen.
                        </p>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
